
import { format } from 'date-fns'
import { defineComponent } from 'vue'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrDatepicker from '@nextrequestco/components/src/components/NrDatePicker/nr-datepicker.vue'
import NrSentry from '../../../utils/nr_sentry'
import { mapState, mapActions } from 'vuex'

export default defineComponent({
  name: 'request-dates',
  components: {
    NrModal,
    NrIconButton,
    NrFormInput,
    NrIcon,
    NrTooltip,
    NrDatepicker
  },
  props: {
    prettyId: {
      type: String,
      required: true
    },
    date: {
      type: String
    },
    requestSubmitType: {
      type: String
    }
  },
  data() {
    return {
      receivedDateComment: '',
      selectedReceivedDate: null
    }
  },
  computed: {
    ...mapState('request_show', ['currentAction']),
    computedReceivedDate(): String | null {
      const date = format(new Date(this.date), 'MM/dd/yyyy')
      if (date) {
        return date
      }
      return null
    },
    unselectableReceivedDate(): Date[] {
      if (this.computedReceivedDate) {
        return [this.computedReceivedDate]
      } else {
        return []
      }
    },
    formattedReceivedDate(): string {
      const date = format(new Date(this.date), 'MMMM dd, yyyy')
      const submitTypeMap: { [key: string]: string } = {
        Fax: 'via fax',
        Email: 'via email',
        'In person': 'in person',
        Phone: 'via phone',
        Web: 'via web',
        Mail: 'via mail',
        Import: 'via request uploader'
      }

      const submitType = this.requestSubmitType
        ? submitTypeMap[this.requestSubmitType] || 'via web'
        : 'via web'

      return `${date} ${submitType}`
    }
  },
  methods: {
    ...mapActions('request_show', ['setCurrentAction', 'updateReceivedDate']),
    submitReceivedDateChange(): void {
      if (!this.selectedReceivedDate) {
        this.$toasted.error('You must select a received date')
        return
      }
      const params = {
        date: format(new Date(this.selectedReceivedDate), 'MM/dd/yyyy'),
        prettyId: this.prettyId,
        description: this.receivedDateComment
      }
      this.updateReceivedDate(params)
        .then(() => {
          this.setCurrentAction(null)
          this.$toasted.success('Successfully updated the received date')
        })
        .catch((error) => {
          this.$toasted.error(
            'There was an error updating the received date for the request. Make sure the date is not the current received date. Please reload the page and try again.'
          )
          NrSentry.captureError(error)
        })
    },
    handleReceivedDateChange(date): void {
      this.selectedReceivedDate = date
    }
  }
})
